const isValidUrl = (_string: string) => {
	const matchpattern =
		/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
	return matchpattern.test(_string);
};

export default isValidUrl;
